import * as React from 'react';
import Settings from '../containers/Settings';

export default (props) => <Settings {...props} />

